<html>


<body>
  <div class="card">
    <div style="max-width: 500px;text-align: justify;">

      <h1>RESUMEN</h1>
      <p> <strong>Rut Solicitante : </strong> {{rutSolicitante}}-{{dvSolicitante}}</p><br>
      <p><strong>Dirección : </strong>{{direccionSolicitante}} </p><br>
      <div>
        <p><strong>Tipo Ingreso:</strong> {{siglas}}</p>
      </div> <br>
      <div>
        <p><strong>Comentario:</strong> {{comentario}}</p>
      </div>
      <!-- <p [innerHTML]="comentario"> </p> -->

      <br>
      <p style="white-space: pre">Para completar la operación haga click en <strong>FINALIZAR</strong> <br /> </p>
    </div>
  </div>
</body>

</html>



<div class="row">
  <div class="col-lg-6 col-md-6 col-sm-6" align="left">
    <button mat-raised-button color="primary" matStepperPrevious>Volver</button>
  </div>
  <div class="col-lg-6 col-md-6 col-sm-6" align="right">
    <button mat-raised-button color="primary" [disabled]="ingresando"
      (click)="crearSolicitudInspeccion()">Finalizar</button>
  </div>
</div>

<ng-template #finalizarMSG>
  <h2 mat-dialog-title>Registro finalizado</h2>
  <mat-dialog-content>
    <p>Se realizó el ingreso de su solicitud.</p>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button matDialogClose mat-raised-button color="warn" id="cancel_mail" data-dismiss="modal"
      (click)="finalizarBTN()">Aceptar</button>
  </mat-dialog-actions>
</ng-template>